import { inject, Injector, runInInjectionContext } from '@angular/core';
import { tapResponse } from '@ngrx/operators';
import { patchState } from '@ngrx/signals';
import { tap } from 'rxjs';
import { GetCittaGQL } from '../../_graphql/generated';

export const init = (injector: Injector, store: any) => () =>
  runInInjectionContext(injector, () => {
    const getter = inject(GetCittaGQL);

    return getter
      .fetch(
        {},
        {
          context: { headers: { 'x-hasura-role': 'anonymous' } },
          fetchPolicy: 'cache-first',
        },
      )
      .pipe(
        tap(() => patchState(store, { loading: true })),
        tapResponse({
          next: (res) => {
            patchState(store, {
              loading: false,
              lista: res.data?.unita_amministrativa_citta,
              failure: undefined,
            });
          },
          error: (error) => {
            patchState(store, {
              loading: false,
              failure: error,
            });
          },
        }),
      );
  });
